import React from 'react';
import { Tooltip as RTooltip } from 'react-tooltip';

import { ReactComponent as InfoIcon } from './icon-info.svg';

import './Tooltip.css';

interface TooltipProps extends React.PropsWithChildren {
  opener?: string;
  link?: string;
}

const Tooltip = ({ children, link, opener }: TooltipProps) => {
  const id = Math.random().toString(36).substring(7);

  return (
    <>
      <div className={'tooltip-wrapper'}>
        <div data-tooltip-id={id}>
          {opener ? <div className={'helperText'}>{opener}</div> : <InfoIcon />}
        </div>
      </div>
      <RTooltip className="custom-tooltip" id={id} clickable>
        <div>
          {children}
          {link && (
            <strong>
              <a href={link} target="_blank" rel="noreferrer">
                Read more
              </a>
            </strong>
          )}
        </div>
      </RTooltip>
    </>
  );
};

export default Tooltip;
